module.exports = __webpack_public_path__ + "static/about-build-fca63746f3c975b5d94c31686513d2d9.svg";